// extracted by mini-css-extract-plugin
export default {"withFullscreen":"Fullscreen_withFullscreen__xSspS","fullscreen":"Fullscreen_fullscreen__1f8Od"};